export {default as vimeo} from "./PlayerVimeo"
export {default as youtube} from "./PlayerYoutube"
export {default as youku} from "./PlayerYouku"
export {default as ina} from "./PlayerIna"
export {default as dailymotion} from "./PlayerDailymotion"


// WEBPACK FOOTER //
// ./vendor/bbs/crt/src/resources/views/components/player/players/index.js